<template>
  <lazy-div :load="doInit">
    <v-layout row wrap>
      <v-flex md12 lg8>
        <v-card>
          <v-tabs v-model="tab">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab href="#details">Details</v-tab>
            <v-tab href="#history">Login History</v-tab>
            <v-tab-item value="details">
              <v-subheader>Particulars</v-subheader>
              <v-divider></v-divider>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12 v-if="user.groupName">
                      <v-subheader class="queryLabel">Member Group</v-subheader>
                      <div>{{user.groupName}}</div>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">Salutation</v-subheader>
                      <div>{{user.salutation}}</div>
                    </v-flex>
                    <v-flex md8 xs12>
                      <v-subheader class="queryLabel">Name</v-subheader>
                      <div>{{user.name}}</div>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">NRIC/Passport</v-subheader>
                      <div>{{user.nricPassport}}</div>
                    </v-flex>
                    <v-flex md8 xs12>
                      <v-subheader class="queryLabel">Date of Birth</v-subheader>
                      <div>{{user.dob}}</div>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">Gender</v-subheader>
                      <div>{{user.gender}}</div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-subheader>Contact Information</v-subheader>
              <v-divider></v-divider>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">Email</v-subheader>
                      <div>{{user.email}}</div>
                    </v-flex>
                    <v-flex md8 xs12>
                      <v-subheader class="queryLabel">Mobile No.</v-subheader>
                      <div>{{user.mobileNo}}</div>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">Home No.</v-subheader>
                      <div>{{user.telNo1}}</div>
                    </v-flex>
                    <v-flex md8 xs12>
                      <v-subheader class="queryLabel">Office No.</v-subheader>
                      <div>{{user.telNo2}}</div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-subheader>Residential Address</v-subheader>
              <v-divider></v-divider>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div v-if="user.postalCode">
                        {{user.add1}} {{user.add2}} <span v-if="user.add3">#{{user.add3}}</span> {{user.add4}}, Singapore {{user.postalCode}}
                      </div>
                      <div v-else>-</div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-subheader>Mailing Address</v-subheader>
              <v-divider></v-divider>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div v-if="user.mailPostalCode">
                        {{user.mailAdd1}} {{user.mailAdd2}} <span v-if="user.mailAdd3">#{{user.mailAdd3}}</span> {{user.mailAdd4}}, Singapore {{user.mailPostalCode}}
                      </div>
                      <div v-else>-</div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-tab-item>
            <v-tab-item value="history">
              <v-card-text>
                <login-history :apiURI="menu.loginHistory"></login-history>
              </v-card-text>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </lazy-div>
</template>

<script>
import { salutation, gender } from '@/const/underwriting'
import { formatDisplayDate } from '@/utils/date'
import { extractMenu } from '@/utils/extract'
import { expandURI } from '@/utils/ajax'
import LoginHistory from './LoginHistory'
export default {
  data() {
    return {
      user: {
        salutation: null,
        name: null,
        nricPassport: null,
        dob: null,
        gender: null,
        isStudent: false,
        email: null,
        mobileNo: null,
        telNo1: null,
        telNo2: null,
        postalCode: null,
        add1: null,
        add2: null,
        add3: null,
        add4: null,
        mailAdd: null,
        mailPostalCode: null,
        mailAdd1: null,
        mailAdd2: null,
        mailAdd3: null,
        mailAdd4: null,
        groupName: null
      },
      menu: [],
      tab: null
    }
  },
  methods: {
    async doInit() {
      try {
        const apiURI = this.$store.state.adminMember.menu.memberGet
        const expand = {
          id: this.id
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result
        if (data) {
          if (data.salutation) {
            this.user.salutation = salutation[data.salutation]
          }
          this.user.name = data.name
          this.user.nricPassport = data.nricPassport
          if (data.dob) {
            this.user.dob = formatDisplayDate(data.dob)
          }
          if (data.gender) {
            this.user.gender = gender[data.gender]
          }
          this.user.email = data.email
          if (data.mobileNo) {
            this.user.mobileNo = data.mobileNo
          } else {
            this.user.mobileNo = '-'
          }
          if (data.telNo1) {
            this.user.telNo1 = data.telNo1
          } else {
            this.user.telNo1 = '-'
          }
          if (data.telNo2) {
            this.user.telNo2 = data.telNo2
          } else {
            this.user.telNo2 = '-'
          }
          this.user.add1 = data.add1
          this.user.add2 = data.add2
          this.user.add3 = data.add3
          this.user.add4 = data.add4
          this.user.postalCode = data.postalCode
          this.user.mailAdd = data.mailAdd
          this.user.mailAdd1 = data.mailAdd1
          this.user.mailAdd2 = data.mailAdd2
          this.user.mailAdd3 = data.mailAdd3
          this.user.mailAdd4 = data.mailAdd4
          this.user.mailPostalCode = data.mailPostalCode
          this.user.groupName = data.groupName

          // Extract menu
          this.menu = extractMenu(result.data._links)
        }
      } catch (error) {
        throw error
      }
    }
  },
  props: ['id'],
  components: {
    LoginHistory
  }
}
</script>

<style>
</style>
